export default {
	// Config
	apiKey: "AIzaSyAKRjVkPV9XBuo9iXyn_rIeNmqzYnCkAkM",
  authDomain: "budtech-mytrace.firebaseapp.com",
  projectId: "budtech-mytrace",
  storageBucket: "budtech-mytrace.firebasestorage.app",
  messagingSenderId: "513749664653",
  appId: "1:513749664653:web:96a399a1be626577c3f3c4"
};
